import React from 'react'
import { UserRoundPlus } from 'lucide-react'

const icon = props => <UserRoundPlus size={18} {...props} />

export default icon
